import { BillableMatterListItem } from 'types/billable-matters';
import { injectCountEndPoint, portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIMattersSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['BillableMatters', 'BillableMattersCount'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getBillableMattersWithFilters: accumulatedQueryWithFilters<BillableMatterListItem>(
                builder,
                '/v1/billable-matters',
                {
                    providesTags: ['BillableMatters'],
                }
            ),
            getBillableMattersCount: injectCountEndPoint(builder, '/v1/billable-matters', 'BillableMattersCount'),
        }),
        overrideExisting: false,
    });

export const {
    useLazyGetBillableMattersWithFiltersQuery,
    useLazyGetBillableMattersCountQuery,
    useGetBillableMattersCountQuery,
} = APIMattersSlice;
